/**
 * Hier werden die Tabs eingebunden
 */

import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Grid, Paper, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import DashboardNetworkContentTabs from '../../User/UserDashboard/components/DashboardNetworkContentTabs'
import SettingsFacebookConnect from './SettingsFacebookConnect'
import SettingsInstagramConnect from './SettingsInstagramConnect'
import SettingsGoogleConnect from './SettingsGoogleConnect'
import {
  getConnectionChanged,
  getFacebookRedirect,
  getUser,
} from '../../../store/common/common.selectors'

import {
  SocialmediaConnection,
} from '@professocialApi/professocial-core-frontend-api/models'
import { NetworkType } from '@3m5/sm_publish-frontend-api'
import { getCurrentUserInitiated } from '../../../store/common/common.actions'
import useQuery from '../../../util/useQuery'

export interface ISettingsConnectProps {
  connection?: SocialmediaConnection
}

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    width: '100%',
    padding: theme.spacing(5),
  },
}))

const SettingsConnect: React.FC = () => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const user = useSelector(getUser)
  const authorizationUrl: string |undefined = useSelector(getFacebookRedirect)
  const connectionChanged: boolean = useSelector(getConnectionChanged)

  const query = useQuery()
  const dispatchGetUser = useCallback(() => dispatch(getCurrentUserInitiated()), [dispatch])

  const getDefaultActiveTab = useCallback(() => {
    const startTab = query.get('startTab')
    switch (startTab) {
    case 'instagram': 
      return NetworkType.Instagram
    case 'gmb':
      return NetworkType.GoogleMyBusiness
    case 'facebook':
      return NetworkType.Facebook
    default:
      return NetworkType.Facebook
    }
  }, [query])

  const tabs: NetworkType[] = [NetworkType.Facebook, NetworkType.Instagram, NetworkType.GoogleMyBusiness]
  const [activeTab, setActiveTab] = React.useState<NetworkType>(getDefaultActiveTab())

  const [facebookConnection, setFacebookConnection] = useState<SocialmediaConnection>()
  const [googleConnection, setGoogleConnection] = useState<SocialmediaConnection>()

  // First, we check which connections exist at all and enter the state with the respective module
  useEffect(() => {
    const connections: SocialmediaConnection[] | undefined = user && user.smConnections
    connections && connections.map((connection: SocialmediaConnection) => {
      if (connection.networkType === NetworkType.Facebook) {
        setFacebookConnection(connection)
      }
      if (connection.networkType === NetworkType.GoogleMyBusiness) {
        setGoogleConnection(connection)
      }
    })
  }, [user],
  )

  useEffect(() => {
    if (authorizationUrl) {
      window.location.replace(authorizationUrl)
    }
  }, [authorizationUrl],
  )

  useEffect(() => {
    connectionChanged && dispatchGetUser()
  }, [connectionChanged],
  )

  return (
    <>
      <DashboardNetworkContentTabs
        activeItem={activeTab} tabs={tabs} onChangeTab={(tab: NetworkType) => {
          setActiveTab(tab)
        }}
      />
      <Grid
        container
        direction='row'
      >
        <Grid container item xs={12}>
          <Paper className={classes.paper}>
            {activeTab === NetworkType.Facebook &&
              <SettingsFacebookConnect connection={facebookConnection} />}
            {activeTab === NetworkType.Instagram &&
              <SettingsInstagramConnect connection={facebookConnection} />}
            {activeTab === NetworkType.GoogleMyBusiness &&
              <SettingsGoogleConnect connection={googleConnection} />}
          </Paper>
        </Grid>
      </Grid>
    </>
  )
}

export default SettingsConnect
